import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ChangeEmailResendOtp = gql`
  mutation ChangeEmailResendOtp {
    changeEmailResendOtp {
      ... on ChangeEmailResendOtpSuccess {
        success
        __typename
      }
      ... on ChangeEmailTooManyAttempts {
        ...error
        __typename
      }
      ... on ChangeEmailError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;

export default ChangeEmailResendOtp;
